import { render, staticRenderFns } from "./IcoContentMarketplace.vue?vue&type=template&id=5e4aed54"
import script from "./IcoContentMarketplace.vue?vue&type=script&lang=js"
export * from "./IcoContentMarketplace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports